import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

export const getTerms = async (): Promise<AxiosResponse<File>> => {
  return await authRequest.get("/v1/user/terms", { responseType: "blob" });
};
